module.exports = __webpack_public_path__ + "img/balao_balao_2.0be40203.svg";